import { render, staticRenderFns } from "./template-modal.vue?vue&type=template&id=2810a6da"
import script from "./template-modal.vue?vue&type=script&lang=js"
export * from "./template-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports